import React from "react"
import { Heading, Text } from "../../common/typography"
import { ReadMoreLink } from "../../common/read-more"
import styled from "styled-components"
import { theme } from "../../../tokens"
import { useMobile } from "../../../utils/use-mobile"

const ResourceItemGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-template-rows: 1fr;
  column-gap: 50px;
  padding: 50px 0px;
  align-items: center;
  @media (max-width: ${theme.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`

const ResourceImage = styled.img`
  width: 400px;
  height: 300px;
  object-fit: cover;
  @media (max-width: ${theme.breakpoints.lg}) {
    width: 100%;
    height: 220px;
  }
  @media (max-width: ${theme.breakpoints.md}) {
    height: 350px;
    margin-bottom: 42px;
  }
`

export const ResourceItem = ({ title, snippet, url, image }) => {
  const isMobile = useMobile()
  if (isMobile) {
    return (
      <ResourceItemGrid>
        <ResourceImage src={image} />
        <div>
          <Heading>{title}</Heading>
          <Text>{snippet}</Text>
          <ReadMoreLink url={url}></ReadMoreLink>
        </div>
      </ResourceItemGrid>
    )
  } else {
    return (
      <ResourceItemGrid>
        <div>
          <Heading>{title}</Heading>
          <Text>{snippet}</Text>
          <ReadMoreLink url={url}></ReadMoreLink>
        </div>
        <ResourceImage src={image} />
      </ResourceItemGrid>
    )
  }
}
